export const ACTIONS = {
  USER_INVENTORIES_FETCH_START: 'USER_INVENTORIES_FETCH_START',
  USER_INVENTORIES_FETCH_SUCCESS: 'USER_INVENTORIES_FETCH_SUCCESS',
  USER_INVENTORIES_FETCH_FAILURE: 'USER_INVENTORIES_FETCH_FAILURE',
  USER_INVENTORIES_FETCH_RESET: 'USER_INVENTORIES_FETCH_RESET',

  USER_INVENTORY_FETCH_START: 'USER_INVENTORY_FETCH_START',
  USER_INVENTORY_FETCH_SUCCESS: 'USER_INVENTORY_FETCH_SUCCESS',
  USER_INVENTORY_FETCH_FAILURE: 'USER_INVENTORY_FETCH_FAILURE',
  USER_INVENTORY_FETCH_RESET: 'USER_INVENTORY_FETCH_RESET',

  USER_INVENTORY_CREATE_START: 'USER_INVENTORY_CREATE_START',
  USER_INVENTORY_CREATE_SUCCESS: 'USER_INVENTORY_CREATE_SUCCESS',
  USER_INVENTORY_CREATE_FAILURE: 'USER_INVENTORY_CREATE_FAILURE',
  USER_INVENTORY_CREATE_RESET: 'USER_INVENTORY_CREATE_RESET',

  USER_INVENTORY_UPDATE_START: 'USER_INVENTORY_UPDATE_START',
  USER_INVENTORY_UPDATE_SUCCESS: 'USER_INVENTORY_UPDATE_SUCCESS',
  USER_INVENTORY_UPDATE_FAILURE: 'USER_INVENTORY_UPDATE_FAILURE',
  USER_INVENTORY_UPDATE_RESET: 'USER_INVENTORY_UPDATE_RESET',

  USER_INVENTORY_DELETE_START: 'USER_INVENTORY_DELETE_START',
  USER_INVENTORY_DELETE_SUCCESS: 'USER_INVENTORY_DELETE_SUCCESS',
  USER_INVENTORY_DELETE_FAILURE: 'USER_INVENTORY_DELETE_FAILURE',
  USER_INVENTORY_DELETE_RESET: 'USER_INVENTORY_DELETE_RESET',
};
